import React, {useState, useEffect} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import {makeStyles} from '@material-ui/styles';
import {Divider, Drawer, List, Grid} from '@material-ui/core';
import MenuBookIcon from '@material-ui/icons/MenuBook';

import {Profile, SidebarNav, Item} from './components';

import {modulos} from '../../../../config';
import {hooks, helpers} from 'lib.front';
import {inicio} from 'config/modulos';

const {useApolloQ} = hooks;

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
   drawer: {
      width: drawerWidth,
      flexShrink: 0,
      whiteSpace: 'nowrap',
      [theme.breakpoints.up('lg')]: {
         marginTop: 64,
         height: 'calc(100% - 64px)'
      }
   },
   nav: {
      marginBottom: theme.spacing(2)
   },
   drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.enteringScreen
      })
   },
   drawerClose: {
      transition: theme.transitions.create('width', {
         easing: theme.transitions.easing.sharp,
         duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
         width: theme.spacing(9) + 1
      }
   },
   root: {
      backgroundColor: theme.palette.white,
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: theme.spacing(2)
   },
   divider: {
      margin: theme.spacing(0.5, 0)
   }
}));

const query = gql`
   query getData {
      tutorialNivel(nivel: 1) {
         codigo
         denominacion
      }
   }
`;

const Sidebar = props => {
   const {open, variant, onClose, onOpen, className, ...rest} = props;

   const classes = useStyles();
   const {data} = useApolloQ(query);
   const [capacitaciones, setCapacitaciones] = useState([]);

   useEffect(() => {
      if (
         data !== undefined &&
         data['tutorialNivel'] !== null &&
         data['tutorialNivel'] !== undefined
      ) {
         asignarCapacitaciones(data['tutorialNivel']);
      }
   }, [data]);

   async function asignarCapacitaciones(arreglo) {
      const auxArr = await Promise.all(
         arreglo.map(async (item, index) => {
            return {
               title: item.denominacion,
               href: `/capacitaciones/${item.codigo}`
            };
         })
      );
      if (auxArr !== undefined && auxArr.length > 0) {
         setCapacitaciones(auxArr);
      }
   }
   return (
      <Drawer
         anchor="left"
         classes={{
            paper: clsx(classes.drawer, {
               [classes.drawerOpen]: open,
               [classes.drawerClose]: !open
            })
         }}
         onClose={onClose}
         open={open}
         variant={variant}
         onMouseEnter={onOpen}
         onMouseLeave={onClose}
      >
         <div
            {...rest}
            className={clsx(classes.root, {
               [classes.drawerOpen]: open,
               [classes.drawerClose]: !open
            })}
         >
            <Grid container>
               <Grid item xs={12}>
                  <Profile />
               </Grid>
               <Grid item xs={12}>
                  <Divider className={classes.divider} />
                  <List>
                     <Item
                        key={inicio.title}
                        href={inicio.href}
                        title={inicio.title}
                        icon={inicio.icon}
                        noAnidado
                     />
                  </List>
               </Grid>
               <Grid item xs={12}>
                  <Divider className={classes.divider} />
                  {capacitaciones.length > 0 && (
                     <>
                        <SidebarNav
                           title="Capacitaciones"
                           icon={<MenuBookIcon />}
                           pages={capacitaciones}
                        />
                        <Divider className={classes.divider} />
                     </>
                  )}
                  {!helpers.hidden(modulos.atenciones) && (
                     <>
                        <SidebarNav
                           title={modulos.atenciones.title}
                           icon={modulos.atenciones.icon}
                           pages={modulos.atenciones.pages}
                        />
                        <Divider className={classes.divider} />
                     </>
                  )}
                  {!helpers.hidden(modulos.mantenimientos) && (
                     <>
                        <SidebarNav
                           title={modulos.mantenimientos.title}
                           icon={modulos.mantenimientos.icon}
                           pages={modulos.mantenimientos.pages}
                        />
                        <Divider className={classes.divider} />
                     </>
                  )}
                  {!helpers.hidden(modulos.procesos) && (
                     <>
                        <SidebarNav
                           title={modulos.procesos.title}
                           icon={modulos.procesos.icon}
                           pages={modulos.procesos.pages}
                        />
                        <Divider className={classes.divider} />
                     </>
                  )}
                  {!helpers.hidden(modulos.reportes) && (
                     <>
                        <SidebarNav
                           title={modulos.reportes.title}
                           icon={modulos.reportes.icon}
                           pages={modulos.reportes.pages}
                        />
                        <Divider className={classes.divider} />
                     </>
                  )}
               </Grid>
            </Grid>
         </div>
      </Drawer>
   );
};

Sidebar.propTypes = {
   className: PropTypes.string,
   onClose: PropTypes.func,
   open: PropTypes.bool.isRequired,
   variant: PropTypes.string.isRequired
};

export default Sidebar;
